
import { Route } from 'vue-router';
import store from '../../store/store';
import { Component } from 'vue-property-decorator';
import GroupDetailsBase from './GroupDetailsBase.vue';
import { performance } from '../../shared/services/PerformanceService';

@Component({})
export default class TribeDetails extends GroupDetailsBase {
    async beforeRouteEnter(to: Route, from: Route, next: Function) {
        performance.track(`hive-details-${(to.params as any).id}`);
        await store.dispatch('details/fetchTribeAggregate', (to.params as any).id);
        next();
    }
    markPerformance() {
        this.$nextTick(function() {
            performance.end(`hive-details-${this.id}`);
        });
    }
}
